import React, { useEffect, useRef, useState } from "react";
import { Buttons, Card, Container, DivButtom, Forms, Header, Title } from "./style";
import Input from "../../Input";
import Button from "../../Button";
import { Alert } from "../../../utils/Alert";
import Icone from "../../../utils/Icone";
import api from "../../../Services/api";
import Swal from "sweetalert2";
import InputSelect from "../../Select";
import User from "../../../Services/user";

export default function EditUsario({ isActivedEdit, setIsActivedEdit, usuario }) {
  if (isActivedEdit === false && !usuario.length) return;
  const [Nome, setNome] = useState("");
  const [Matricula, setMatricula] = useState("");
  const [Sobrenome, setSobrenome] = useState("");
  const [Email, setEmail] = useState("");
  const [Perfil, setPerfil] = useState("");
  const [Coordenador] = useState(User.perfil() === "coordenador");
  const [Secretaria] = useState(User.perfil() === "secretaria");
  const [proprio_user] = useState(User.id() === usuario?.id);
  const modalRef = useRef();
  let optionsPerfil = [];

  if (proprio_user) {
    optionsPerfil = [{ label: User.perfil(), value: User.perfil() }];
  } else if (Coordenador) {
    optionsPerfil = [
      { label: "professor", value: "professor" },
      // { label: "coordenador", value: "coordenador" },
    ];
  } else if (Secretaria) {
    optionsPerfil = [
      { label: "secretaria", value: "secretaria" },
      { label: "coordenador", value: "coordenador" },
      { label: "professor", value: "professor" },
    ];
  }

  function setAllFalse() {
    setNome("");
    setEmail("");
    setPerfil("");
    setMatricula("");
  }

  useEffect(() => {
    if (isActivedEdit && usuario) {
      setNome(usuario.nome);
      // setSobrenome(usuario.nome);
      setEmail(usuario.email);
      setPerfil(usuario.perfil);
      setMatricula(usuario.matricula);
    }
  }, [usuario, isActivedEdit]);

  async function HandleManualSubmit(e) {
    const isProfessorOrCoordenador = ["coordenador", "professor"].includes(Perfil);

    const data = {
      id_usuario: usuario.id,
      nome: Nome,
      email: Email,
      matricula: isProfessorOrCoordenador ? Matricula : 0,
      sobrenome: Sobrenome,
      perfil: Perfil,
    };
    const isValidEmail = data.email.includes("@") && data.email.includes(".");
    const isValidMatricula =
      !isProfessorOrCoordenador || (isProfessorOrCoordenador && data.matricula && data.matricula > 0);

    if (data.perfil === null || data.perfil === undefined || data.perfil === "") {
      Alert({ tipo: "Erro2", mensagem: "Selecione um perfil" });
      return;
    }

    if (
      isValidEmail &&
      data.nome &&
      isValidMatricula &&
      data.perfil != null &&
      data.perfil != undefined &&
      data.perfil != ""
    ) {
      if (
        usuario.nome === Nome &&
        usuario.perfil === Perfil &&
        usuario.email === Email &&
        usuario.matricula === Matricula
      ) {
        return await Alert({ tipo: "Erro2", mensagem: "Altere algum dado para salvar a alteração" });
      }
      try {
        const res = await api.patch("/usuario/atualizar", { data });
        await Alert({
          tipo: "Sucesso2",
          mensagem: res?.data?.mensagem?.split("Por")[0] || "Usuario atualizado com sucesso!",
        });
        setAllFalse();
        setIsActivedEdit(false);
      } catch (err) {
        console.log(err);
        await Alert({
          tipo: "Erro2",
          mensagem: err?.response?.data?.erro?.split("|")[0] || "Erro ao atualizar usuario",
        });
      }
    } else {
      await Alert({ tipo: "Erro2", mensagem: "Por favor, preencha todos os campos obrigatórios corretamente." });
    }
  }

  return (
    <Container
      ref={modalRef}
      onClick={(e) => {
        if (modalRef.current === e.target) {
          setAllFalse();
          setIsActivedEdit(false);
        }
      }}
    >
      <Card>
        <Header>
          <Buttons
            onClick={() => {
              setAllFalse();
              setIsActivedEdit(false);
            }}
          >
            <Icone name={"X"} color={" #3a3f86"} size={36} />
          </Buttons>
          <Title>Edição do Usuario</Title>
        </Header>
        <Forms>
          <InputSelect
            Style1={{ color: "#000" }}
            Style2={{ width: "30vh", marginBottom: "-1.5rem" }}
            Label={"Perfil"}
            Options={optionsPerfil}
            Default={Perfil ? Perfil : "-"}
            Disabled={proprio_user && Perfil ? Perfil : null}
            OnChange={(e) => setPerfil(e.target.value)}
          />
          <Input
            width="30vh"
            color="black"
            type={"text"}
            placeholdercolor="black"
            placeholder="Nome"
            required={"true"}
            value={Nome}
            event={(e) => {
              setNome(e.target.value);
            }}
          />
          {["coordenador", "professor"].includes(Perfil) ? (
            <>
              {/* <Input
                width="30vh"
                color="black"
                type={"text"}
                placeholdercolor="black"
                placeholder="Sobrenome"
                required={"true"}
                value={Sobrenome}
                event={(e) => {
                  setSobrenome(e.target.value);
                }}
              /> */}
              <Input
                width="30vh"
                color="black"
                type="text"
                placeholdercolor="black"
                placeholder="Matrícula"
                required={true}
                pattern="[0-9]*"
                inputMode="numeric"
                value={Matricula}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/\D/g, "");
                }}
                event={(e) => setMatricula(e.target.value)}
              />
            </>
          ) : null}
          <Input
            width="30vh"
            placeholdercolor="black"
            color="black"
            type={"email"}
            placeholder={"Email"}
            required={"true"}
            value={Email}
            event={(e) => {
              setEmail(e.target.value);
            }}
          />
        </Forms>
        <DivButtom>
          <Button
            id={"button"}
            width="20vh"
            event={(e) => {
              e.preventDefault();
              HandleManualSubmit(e);
            }}
            placeholder="Editar Usuario "
          />
        </DivButtom>
      </Card>
    </Container>
  );
}
